import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import "./noticias.css";
import CardSkeleton from "../../components/Skeleton/CardSkeleton";
import TextSkeleton from "../../components/Skeleton/TextSkeleton";
import ImageSkeleton from "../../components/Skeleton/ImageSkeleton";

import { getTarjetasInicio } from "../../config/services/strapi/home";
import { getNoticiasList } from "../../config/services/strapi/noticias";

interface Noticia {
  id: number;
  titulo: string;
  fecha: string;
  image: string;
  link: string;
}

const NoticiaCard = ({ item }: { item: Noticia }) => (
  <div className="card-noticia">
    <a href={item.link} className="card-link">
      <div className="wrapper-imagen-noticia">
        <img src={item.image} alt={item.titulo} className="imagen-noticia" />
        <div className="overlay-verde"></div>
      </div>
      <div className="card-cuerpo">
        <h3 className="card-titulo">{item.titulo}</h3>
        <hr className="card-divider" />
        <span className="card-fecha">{item.fecha}</span>
      </div>
    </a>
  </div>
);

export default function Noticias() {
  const [heroData, setHeroData] = useState<any>(null);
  const [noticiasData, setNoticiasData] = useState<Noticia[]>([]);
  const [loading, setLoading] = useState(true);

  const bgImage = heroData?.portada?.url ? `url(${heroData.portada.url})` : "none";

  const renderHeroTitle = () => {
    if (loading) return "NOTICIAS";
    const texto = heroData?.titulo || heroData?.Titulo || "NOTICIAS";
    
    return texto.split(" ").map((w: string, i: number) => (
      <React.Fragment key={i}>
        {w} {i === 0 && <br />}
      </React.Fragment>
    ));
  };

  useEffect(() => {
    async function loadData() {
      try {
        const [tarjetas, apiNoticias] = await Promise.all([
          getTarjetasInicio(),
          getNoticiasList(),
        ]);

        const tarjetaHero = tarjetas.find((t: any) =>
          t.titulo?.toUpperCase() === "NOTICIAS" || t.Titulo?.toUpperCase() === "NOTICIAS"
        );
        setHeroData(tarjetaHero);

        const mappedNoticias = apiNoticias.map((item: any) => ({
          id: item.id,
          titulo: item.descripcionImage?.[0]?.children?.[0]?.text || "Sin título",
          fecha: item.anoImage || "",
          image: item.image?.url || "",
          link: item.slug ? `/noticias/${item.slug}` : `/noticias/${item.id}`
        }));

        setNoticiasData(mappedNoticias);
      } catch (error) {
        console.error("Error cargando noticias:", error);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  return (
    <>
      <section className="section-noticias">
        <div className="section-inner-noticias">
          <div className="col-media-noticias">
            {loading ? (
              <ImageSkeleton className="h-full" />
            ) : (
              <div
                className="media-cover-noticias"
                style={{ backgroundImage: bgImage }}
              />
            )}
          </div>
          <div className="col-text-noticias noticias">
            {loading ? (
              <TextSkeleton />
            ) : (
              <h1>
                <span>{renderHeroTitle()}</span>
              </h1>
            )}
          </div>
        </div>
      </section>

      <section className="section-principal-noticias">
        <div className="contenedor-principal-noticias">
          <div className="columna-texto-noticias">
            <p className="texto-descripcion-noticias">
              El proyecto de barrio sostenible fue presentado a la Municipalidad de Estación Central
              en febrero de 2020. Para su materialización, se requiere la aprobación del cambio de
              uso de suelo, ya que la normativa actual contempla exclusivamente la producción de gas
              en este lugar. Tras esta tramitación, que puede ser parte del Plan Regular Comunal o
              canalizarse en forma independiente de acuerdo con lo que definan las autoridades, el
              proyecto pasaría a una segunda etapa, que contempla instancias de participación
              ciudadana para ser evaluada por los vecinos de la comuna y recoger la visión de la comunidad.
            </p>
          </div>
        </div>
      </section>

      <section className="section-principal-noticias bg-gris-claro">
        <div className="contenedor-noticias">

          <div className="mobile-carousel">
            {loading ? (
              <CardSkeleton className="max-w-full" />
            ) : (
              <Swiper
                modules={[Pagination]}
                spaceBetween={20}
                slidesPerView={1.1}
                centeredSlides={true}
                pagination={{ clickable: true }}
              >
                {noticiasData.map((item) => (
                  <SwiperSlide key={item.id}>
                    <NoticiaCard item={item} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>

          <div className="desktop-grid">
            {loading
              ? Array.from({ length: 3 }).map((_, index) => (
                <CardSkeleton key={`noticia-skeleton-${index}`} className="max-w-full" />
              ))
              : noticiasData.map((item) => (
                <NoticiaCard key={item.id} item={item} />
              ))}
          </div>
        </div>
      </section>
    </>
  );
}